<div (click)="copyId()" [matTooltip]="fullId" [ngClass]="'block-id_' + mode" class="block-id" tabindex="0">
  <span class="block-id__label">ID:</span>
  <span class="block-id__value">{{ fullId }}</span>
  <mat-icon [svgIcon]="AppIcon.COPY_ID" class="block-id__icon"></mat-icon>
</div>
